import { formatDate } from '@src/common';

interface ScheduledItem {
  scheduleDate?: string | null;
  formattedScheduleTimeMinutes?: string | null;
}

/**
 * Builds the display label for a cart/sale item schedule: date, time, or the caller's
 * fallback text when the item has neither. Each surface supplies its own prefix and
 * fallback wording.
 */
export const formatItemSchedule = (
  item: ScheduledItem,
  options: { datePrefix?: string; fallbackText?: string } = {},
): string => {
  const { datePrefix, fallbackText = '' } = options;
  const formattedDate = item.scheduleDate ? formatDate(item.scheduleDate) : '';
  const date = formattedDate && datePrefix ? `${datePrefix} ${formattedDate}` : formattedDate;

  if (item.formattedScheduleTimeMinutes) {
    return `${date} - ${item.formattedScheduleTimeMinutes}`;
  }

  return date || fallbackText;
};
